//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultLayout from '~/layouts/default.vue';
import PrimaryHeader from '~/components/headers/PrimaryHeader';

export default {
    name: 'bursary',

    components: {
        DefaultLayout,
        PrimaryHeader,
    },

    data() {
        return {
            loading: true,
            showExtendBursaryModal: false,
            showPublishBursaryModal: false,
            showScheduleBursaryPublicationModal: false,
        };
    },

    computed: {
        bursary() {
            return this.$store.getters['jobs/single/getSingleJob'] || {};
        },

        bursaryTitle() {
            return this.bursary?.title || 'Bursary';
        },

        canModifyBursary() {
            return this.bursary.status !== 'Published';
        },

        published() {
            return this.bursary.status === 'Published';
        },

        isScheduledForPublication() {
            return Boolean(this.bursary.publish_schedule);
        },

        scheduledPublishDate() {
            if (!this.isScheduledForPublication) return;

            const today = new Date();
            const scheduledDate = this.$dayjs(this.bursary.publish_schedule.scheduled_date);

            if (scheduledDate.isBefore(today)) return;

            const dateTime = scheduledDate.format('D MMM @ hh:mm a');

            return `Publishes on ${dateTime}`;
        },

        timeLeft() {
            let date = new Date();
            const date1 = this.$dayjs(this.bursary?.expires);
            return date1.diff(date, 'day') || null;
        },

        timeStatus() {
            if (!this.timeLeft || this.timeLeft < 0) return 'text-copy-primary';
            if (this.timeLeft < 15) return 'text-warning';
            if (this.timeLeft > 15) return 'text-success';
        },
    },

    watch: {
        $route(to, from) {
            if (to.params.id !== from.params.id) {
                this.getBursary();
            }
        },
    },

    created() {
        this.getBursary();
    },

    methods: {
        editBursary() {
            this.$store.dispatch('jobs/draft/setCurrentStep', 1);
            this.$router.push(this.localePath({ path: '/bursaries/draft/' + this.bursary.uuid }));
        },

        confirmUnpublish() {
            this.$modal.show({
                type: this.published ? 'danger' : 'info',
                title: 'Unpublish Bursary',
                body: 'Are you sure you want to unpublish this bursary?',
                primary: {
                    label: 'Unpublish',
                    theme: this.published ? 'red' : 'indigo',
                    action: () => this.unPublishBursary(),
                },
                secondary: {
                    label: 'Cancel',
                    theme: 'white',
                    action: () => ({}),
                },
            });
        },

        confirmExtend() {
            this.showExtendBursaryModal = true;
        },

        confirmDelete() {
            this.$modal.show({
                type: 'danger',
                title: 'Delete bursary',
                body: 'Are you sure you want to delete this bursary? All of the data will be permanently removed and the bursary will no longer be available. This action cannot be undone.',
                primary: {
                    label: 'Delete',
                    theme: 'red',
                    action: () => this.deleteBursary(),
                },
                secondary: {
                    label: 'Cancel',
                    theme: 'white',
                    action: () => ({}),
                },
            });
        },

        bursaryExtended() {
            this.showExtendBursaryModal = false;
            this.$toast.success('Successfully extended bursary');
        },

        deleteBursary() {
            this.$store.dispatch('jobs/draft/deleteJobPost', this.$route.params.id).then((res) => {
                this.$toast.success('Successful deleted bursary');
                this.$router.push(this.localePath({ name: 'bursaries' }));
            });
        },

        async unPublishBursary() {
            await this.$store
                .dispatch('jobs/draft/unPublishJobPost', this.$route.params.id)
                .then((res) => {
                    this.$toast.success('Successfully un-published bursary');
                    this.getBursary();
                })
                .catch((err) => {
                    let errorMessage = err.response.data.message.replace('_', ' ');
                    this.$toast.danger(errorMessage);
                });
        },

        bursaryPublished() {
            this.$toast.success('Successfully published bursary.');

            this.showPublishBursaryModal = false;

            this.$router.push(this.localePath({ name: 'bursaries' }));
        },

        async getBursary() {
            await this.$store.dispatch('jobs/single/getSingleJob', this.$route.params.id);
            await this.setSelectedBursary();
        },

        async setSelectedBursary() {
            await this.$store.dispatch('jobs/setSelectedJob', this.bursary);
        },

        editPublicationSchedule() {
            this.showScheduleBursaryPublicationModal = true;
        },

        unschedulePublication() {
            this.$store
                .dispatch('jobPublishSchedules/delete', this.bursary.publish_schedule.uuid)
                .then(() => {
                    this.$toast.success('Bursary publication unscheduled.');
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
